import React, { FC, useMemo } from 'react';
import { Platform, Image as RNImage, TouchableOpacity } from 'react-native';
import { get, isEmpty, isUndefined } from 'lodash';
import { useSelector } from 'react-redux';

import { AppVersion } from 'click-types';
import { appInfoSelector } from '@common/redux/selectors/app';
import { defaultURL } from '@common/constants/shared';
import { IImage } from '@common/types/element';
import { getValueBindingComponent } from '@common/utils/component';
import {
  getActions,
  getItemListClick,
} from '@common/utils/handleActions/func/helps';
import createStyles from './style';

const CusImage: FC<IImage> = (attrs) => {
  const appInfo = useSelector(appInfoSelector);
  const url = useMemo(() => {
    const { imageURL, imageType } = attrs;
    const isItemList = !!attrs?.record;
    const dataBinding = isItemList ? attrs?.record : attrs?.data;
    const id = isItemList ? attrs.initId : attrs?.id;

    switch (imageType) {
      case 'uploaded':
        return attrs?.filename1x;

      case 'url':
        // return  get(
        //   dataBinding,
        //   `${id}.imageURL`,
        //   flattedSourceString(imageURL)
        // );
        return getValueBindingComponent(attrs, 'imageURL');

      default:
        // const imageBinding =
        //   get(dataBinding, `${id}.imageUrl`) ||
        //   get(dataBinding, `imageUrl`) ||
        //   get(dataBinding, `${id}.imageUrl.binding`);
        // return imageBinding?.url;
        return getValueBindingComponent(attrs, 'url');
    }
  }, [attrs]);

  const hasPlaceholder = get(attrs, 'imageUrl.binding.options', {});
  const isUrl =
    !url && hasPlaceholder.placeholderImageEnabled
      ? hasPlaceholder?.placeholderImage
      : isEmpty(hasPlaceholder) && !url
      ? ''
      : url;

  const styles = createStyles(attrs, Platform, isEmpty(isUrl));

  const handlePress = (event: any) => {
    event.preventDefault();
    let arrayAction = getActions(attrs.actions);

    attrs.onPress &&
      attrs.onPress(arrayAction, {
        itemListClick: getItemListClick(attrs?.record),
      });
  };
  const defaultSource = hasPlaceholder?.placeholderImageEnabled
    ? hasPlaceholder?.placeholderImage
      ? hasPlaceholder?.placeholderImage
      : defaultURL
    : '';

  return (
    <TouchableOpacity
      disabled={isEmpty(attrs.actions)}
      activeOpacity={1}
      style={styles.container}
      {...(attrs.actions && {
        onPress: handlePress,
      })}
    >
      {isEmpty(isUrl) &&
      !hasPlaceholder?.placeholderImageEnabled ? null : Platform.OS !==
        'web' ? (
        <RNImage
          style={[styles.img]}
          resizeMode={attrs?.imageResize}
          resizeMethod={'resize'}
          source={{ uri: isUndefined(isUrl) ? defaultURL : isUrl }}
          defaultSource={defaultSource}
        />
      ) : (
        <img
          src={isUndefined(isUrl) ? defaultURL : isUrl}
          style={{
            borderRadius:
              appInfo?.version === AppVersion.V4
                ? attrs?.style?.borderRadius
                : attrs.borderRadius,
            objectFit: attrs?.imageResize,
            width: '100%',
            height: '100%',
          }}
        ></img>
      )}
    </TouchableOpacity>
  );
};

export default React.memo(CusImage);
